import React, { Component } from "react";
import { gql, graphql } from "react-apollo";
import moment from "moment";

import Color from "helpers/Color";
import {
  Statistic,
  Loading,
  Breadcrumbs,
  Grid,
  Notifications,
  DatePicker,
  Segment
} from "components/UI";

import RadiatorTimeline from "./RadiatorTimeline";

class Radiator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timelineFrom: moment()
        .subtract(1, "day")
        .valueOf(),
      timelineTo: moment().valueOf()
    };
  }

  handleTimelineDateChange = range => {
    // valueOf gets the milliseconds since epoch
    this.setState({
      timelineFrom: range.startDate.valueOf(),
      timelineTo: range.endDate.valueOf()
    });
  };

  handleTimelineZoom = (timelineFrom, timelineTo) => {
    this.setState({
      timelineFrom: parseInt(timelineFrom, 10),
      timelineTo: parseInt(timelineTo, 10)
    });
  };

  render() {
    const { error, loading, radiator } = this.props.data;

    if (error) return <Notifications.Error message={error.message} />;

    const { id, number, room, unit, building, lastReading } = radiator || {};

    const temperature = lastReading ? Math.round(lastReading.radTemp) : null;
    const buildingPath = loading ? "" : `/buildings/${radiator.building.id}`;

    const breadcrumbs = [
      { name: loading ? "..." : building.name, to: buildingPath },
      { name: "Units", to: `${buildingPath}/units` },
      {
        name: loading ? "..." : unit.name,
        to: loading ? "" : `/units/${unit.id}`
      },
      {
        name: loading ? "..." : `${room.name} Radiator ${number}`,
        to: `/radiators/${id}`
      }
    ];
    return (
      <Grid>
        <Grid.Row>
          <Breadcrumbs items={breadcrumbs} />
        </Grid.Row>
        <Grid.Row>
          <Grid.Col />
          <Grid.Col width={2}>
            {loading ? (
              <Loading />
            ) : (
              <Statistic
                value={temperature ? `${temperature}°` : "N/A"}
                description="Average Radiator Temperature (F)"
                color={temperature ? Color.green : Color.gray}
              />
            )}
          </Grid.Col>
          <Grid.Col />
        </Grid.Row>
        <Grid.Row>
          <Grid.Col>
            <Segment centered>
              {loading ? (
                <Loading />
              ) : (
                <DatePicker
                  onChange={this.handleTimelineDateChange}
                  from={this.state.timelineFrom}
                  to={this.state.timelineTo}
                />
              )}
            </Segment>
          </Grid.Col>
        </Grid.Row>
        <RadiatorTimeline
          radiatorId={id}
          from={this.state.timelineFrom}
          to={this.state.timelineTo}
          onZoom={this.handleTimelineZoom}
        />
      </Grid>
    );
  }
}

const RadiatorQuery = gql`
  query RadiatorQuery($id: Int!) {
    radiator(id: $id) {
      id
      number
      lastReading {
        id
        radTemp
      }
      room {
        id
        name
      }
      unit {
        id
        name
      }
      building {
        id
        name
      }
    }
  }
`;

export default graphql(RadiatorQuery, {
  options: ({ match }) => ({
    variables: {
      id: match.params.radiatorId
    },
    notifyOnNetworkStatusChange: true
  })
})(Radiator);



// WEBPACK FOOTER //
// ./src/components/Radiator/Radiator.jsx